/* istanbul ignore file */
import Head from 'next/head';
import React from 'react';

const title = 'Find a Baby Registry on Zola';
const canonical = 'https://baby.zola.com/search/baby-registry';
const description =
  'Search for and find a baby registry here. Order gifts easily, choose when your gift ships, or send a zero-fee cash gift.';

function Meta(): JSX.Element {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:url" content={canonical} />
      <meta
        property="og:image"
        content="https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/logos/ZOLABABY_ICON-L_BLUE.png"
      />
      <meta name="twitter:site" content="@zola" />
      <meta name="twitter:card" content="summary" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content="Zola Baby" />
    </Head>
  );
}

export default Meta;
